import { css } from '@emotion/css';

export const metadataItem = css`
	margin-bottom: 10px;
`;
